export const Market = {
    CZ: 1,
    SK: 2,
}
export type Market = typeof Market[keyof typeof Market]

export const Markets: [Market, string, string, string][] = [
    [Market.CZ, 'Česká republika', 'Kč', 'CZK'],
    [Market.SK, 'Slovensko', '€', 'EUR'],
]

export const getMarketName = (market: Market | undefined) => {
    return market !== undefined ? Markets.find(([key]) => key === market)?.[1] : undefined
}

export const getMarketCurrency = (market: Market | undefined): Currency => {
    return {
        unit: market !== undefined ? Markets.find(([key]) => key === market)?.[2] : undefined,
        code: market !== undefined ? Markets.find(([key]) => key === market)?.[3] : undefined
    }
}

// export type for currency
export type Currency = {
    unit?: string
    code?: string
}